import { useState } from 'react';
import ArrowLeft from '../assets/icons/ArrowLeft';
import ArrowRight from '../assets/icons/ArrowRight';
import atlantis from "../assets/atlantis.png"
import { PhotoMetadata } from '../features/submissionComponents/PhotoMetaData';

const Slider = ({ images, submissionData, modalHeaderData }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { timestamps, latitudes, longitudes } = submissionData || {};

    // Helper function to get the appropriate value based on whether it's an array or not
    const getValue = (data, index) => {
        if (!data) return null;
        return Array.isArray(data[0]) ? data[0][index] : data[0];
    };

    const goToNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const goToPrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
    };

    const goToIndex = (index) => {
        setCurrentIndex(index);
    };

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    console.log(timestamps, latitudes, longitudes, 'timestamps, latitudes, longitudes', latitudes, longitudes);

    return (
        <div>
            {/* Main Slider */}
            <div className="relative w-[100%] h-32 border rounded-md overflow-hidden">
                <img
                    src={images[currentIndex]}
                    alt={`Slide ${currentIndex}`}
                    className="object-cover w-full h-full cursor-pointer"
                    onClick={openModal}
                />

                <button
                    onClick={goToPrev}
                    className="absolute left-0 top-1/2 transform -translate-y-1/2 w-6 h-6 flex items-center justify-center  rounded-full bg-gray-600 bg-opacity-70 hover:bg-gray-700 transition-colors duration-200 shadow-lg z-10"
                >
                    <ArrowLeft w="14" h="14" />
                </button>

                <button
                    onClick={goToNext}
                    className="absolute right-0 top-1/2 transform -translate-y-1/2 w-6 h-6 flex items-center justify-center  rounded-full bg-gray-600 bg-opacity-70 hover:bg-gray-700 transition-colors duration-200 shadow-lg z-10"
                >
                    <ArrowRight w="14" h="14" />
                </button>

                <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex space-x-2">
                    {images.map((_, index) => (
                        <button
                            key={index}
                            onClick={() => goToIndex(index)}
                            className={`w-4 h-4 rounded-full ${
                                index === currentIndex ? 'bg-gray-400' : 'bg-grayBgNormal'
                            } border border-black hover:bg-gray-500`}
                        />
                    ))}
                </div>
            </div>
            {timestamps && latitudes && longitudes && (
                <PhotoMetadata
                    timestamp={getValue(timestamps, currentIndex)}
                    latitude={getValue(latitudes, currentIndex)}
                    longitude={getValue(longitudes, currentIndex)}
                    className=""
                />
            )}

            {isModalOpen && (
                <div 
                    className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-75 backdrop-blur-sm"
                    onClick={closeModal}
                >
                    <div 
                        className="relative w-full max-w-4xl rounded-[.625rem] bg-grayBgNormal p-6 flex flex-col mx-4"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header with title and close button */}
                        <div className='flex items-center justify-between mb-4'>
                            <p className='text-2xl text-textPrimary font-semibold'>
                                {modalHeaderData?.bountyTitle || 'Image Preview'}
                            </p>
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    closeModal();
                                }}
                                className="rounded-full   bg-[#eeeeee] hover:bg-gray-100 transition-colors"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="37" viewBox="0 0 36 37" fill="none">
<circle cx="18" cy="18.5" r="18" fill="#EEEEEE"/>
<path d="M25.6322 25.7806C25.3391 26.0737 24.8648 26.0737 24.5714 25.7806L18.3525 19.5603L12.1322 25.7806C11.8391 26.0737 11.3648 26.0737 11.0714 25.7806C10.7783 25.4875 10.7783 25.0133 11.0714 24.7198L17.2931 18.5009L11.0723 12.2806C10.7792 11.9875 10.7792 11.5133 11.0723 11.2198C11.3654 10.9267 11.8397 10.9267 12.1331 11.2198L18.3525 17.4416L24.5728 11.2212C24.8659 10.9281 25.3401 10.9281 25.6336 11.2212C25.9267 11.5143 25.9267 11.9886 25.6336 12.282L19.4119 18.5009L25.6322 24.7212C25.9275 25.0119 25.9275 25.49 25.6322 25.7806Z" fill="#737373"/>
</svg>
                            </button>
                        </div>

                        {/* Data Points and Response Type */}
                        {modalHeaderData && (
                            <div className='flex justify-between mb-4 text-sm'>
                                <div>
                                    <p className='text-[#8c8c8c] mb-1'>Data Points</p>
                                    <p className='font-medium text-textPrimary'>{modalHeaderData.dataPointTitle}</p>
                                    <p className='text-textPrimary text-xs'>{modalHeaderData.dataPointDescription}</p>
                                </div>
                                <div className='text-right'>
                                    <p className='text-[#8c8c8c] mb-1'>Response Type</p>
                                    <p className='font-medium text-textPrimary'>{modalHeaderData.responseType}</p>
                                </div>
                            </div>
                        )}

                        {/* Image container with navigation */}
                        <div className="relative rounded-lg w-full bg-gray-100 overflow-hidden " style={{ height: '48vh' }}>
                            <img
                                src={images[currentIndex]}
                                alt={`Slide ${currentIndex}`}
                                className="w-full h-full object-cover"
                            />
                            
                            {/* Captured on Impact Miner overlay */}
                            <div className="absolute bottom-0 left-0 right-0 flex items-center gap-[.375rem]  text-white px-3 pb-3 pt-9 text-base font-medium z-10" style={{ background: 'linear-gradient(0deg, #000 0%, rgba(0, 0, 0, 0.00) 100%)' }}>
                                <div className="w-6 h-6 rounded-full flex items-center justify-center">
                              <img src={atlantis} className='w-full h-full object-cover' alt="" />
                                </div>
                                <span>Captured on Impact Miner</span>
                            </div>
                            
                            {/* Navigation buttons - only show if more than 1 image */}
                            {images.length > 1 && (
                                <>
                                    <button
                                        onClick={goToPrev}
                                        className="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-[#eeeeee] bg-opacity-70 hover:bg-[#d9d9d9] hover:bg-opacity-70 transition-colors duration-200 shadow-lg z-10"
                                    >
                                        <svg className='w-6 h-6' xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
<path d="M21.3664 4.89898L19.3014 2.83398L7.63477 14.5007L19.3014 26.1673L21.3664 24.1023L11.7648 14.5007L21.3664 4.89898Z" fill="#737373"/>
</svg>
                                    </button>

                                    <button
                                        onClick={goToNext}
                                        className="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 text-white rounded-full flex items-center justify-center bg-[#eeeeee] bg-opacity-70 hover:bg-[#d9d9d9] hover:bg-opacity-70 transition-colors duration-200 shadow-lg z-10"
                                    >
                                    <svg  className='w-6 h-6' xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29" fill="none">
<path d="M7.63357 4.89898L9.69857 2.83398L21.3652 14.5007L9.69857 26.1673L7.63357 24.1023L17.2352 14.5007L7.63357 4.89898Z" fill="#737373"/>
</svg>
                                    </button>
                                </>
                            )}
                        </div>

                        {/* Footer with location details */}
                        {timestamps && latitudes && longitudes && (
                            <div className=" pt-2">
                                <PhotoMetadata
                                    timestamp={getValue(timestamps, currentIndex)}
                                    latitude={getValue(latitudes, currentIndex)}
                                    longitude={getValue(longitudes, currentIndex)}
                                    isShowTooltip={false}
                                    className=""
                                />
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Slider;
